import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import { InputControl } from '@bingads-webui/input-control';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { Budget } from '@bingads-webui/hotel-odata-schemas';
import * as putil from '@bingads-webui/primitive-utilities';
import templateUINext from './budget-panel-ui-next-template.pug';
import { instrumentation, SubAccountModel, lightDismissible } from '../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const config = globalContext.require('component/config/index');
const { showError } = globalContext.require('component/toast/index');

lightDismissible();

/**
 * View class for budget setup panel in budget tab
 * @extends Backbone.View
 */
export class BudgetPanelView extends DeterministicView {
  initialize() {
    this.i18n = i18n;

    this.initBudgetInput();

    this.subAccountModel = new SubAccountModel();
    this.subAccountModel.fetch().then(() => {
      this.budgetModel.parse(this.subAccountModel.get('DailyBudget'));
      this.getChild('budget-input').setState({
        value: this.budgetModel.get('Amount'),
      });
      helpers.updateView(this, {
        amount: this.getBudgetText(),
      });
    });

    this.budgetPageScenario = instrumentation.budgetPage.create();
  }

  get events() {
    return {
      'click .grid-menu-chooser-button': (e) => {
        // Since the event will bubble up to the light dismiss manager, it should specify
        // not to dismiss the target element
        e.originalEvent.noDismiss = 'budget-edit-panel'; // eslint-disable-line no-param-reassign

        this.togglePopup();
      },
      'click input.btn.save': 'onSave',
      'click input.btn.cancel': () => {
        this.hidePopup();
      },
    };
  }

  get template() {
    return templateUINext;
  }

  togglePopup() {
    if (this.$('.light-dismissible').hasClass('show')) {
      this.hidePopup();
    } else {
      this.$('.light-dismissible').addClass('show');
      this.$('.light-dismissible').removeClass('hide');
    }
  }

  hidePopup() {
    this.$('.light-dismissible').addClass('hide');
    this.$('.light-dismissible').removeClass('show');
  }

  onSave() {
    if (!this.getChild('budget-input').getState().isValid) {
      return;
    }

    this.subAccountModel.set('DailyBudget', this.budgetModel.toJSON());

    const uiBlockerToken = withUiBlock($('.hotel-center-overview-container'));
    const saveBudgetActivity = this.budgetPageScenario.saveBudget.create();

    saveBudgetActivity.monitorAsync(this.subAccountModel
      .save(['DailyBudget'], { patch: true }))
      .then(() => {
        helpers.updateView(this, {
          amount: this.getBudgetText(),
        });

        saveBudgetActivity.trace('Budget is updated');
      })
      .catch((e) => {
        // todo [rayduan]: handle specific errors when we have error mapping
        const errorCode = putil.get(e, 'errors[0].Code');

        showError(i18n.getString(`HotelCenter_Error_${errorCode}`) || i18n.getString('GenericErrorMessage'));
        saveBudgetActivity.error(JSON.stringify(e));
      }).finally(() => {
        uiBlockerToken();
        this.hidePopup();
      });
  }

  initBudgetInput() {
    const BudgetModel = backboneSchema(Budget, i18n, ['Amount']);

    this.budgetModel = new BudgetModel();

    const budgetInput = new InputControl({
      entity: this.budgetModel,
      field: 'Amount',
      addonText: config.get('AccountCurrencyCode'),
    });

    this.setChild('budget-input', budgetInput);
  }

  getBudgetText() {
    const dailyBudget = this.subAccountModel.get('DailyBudget');
    const amount = dailyBudget ? dailyBudget.Amount : 0;

    return `${i18n.formatDecimalToFixed(amount)} ${config.get('AccountCurrencyCode')}`;
  }
}
